import { loadTheme } from '@fluentui/react';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$4 = "";
var MyKomatsu = {"primary":"#140a9a","primary100":"#3b33b1","primary200":"#253fc8","primary300":"#2219a3","primary400":"#110887","primary600":"#0b065c","primary700":"#06032e","primary800":"#030118","primary900":"#010006","secondary":"#ffc82f","secondary100":"#FCD67F","neutral":"#aaa","neutral100":"#FCFCFC","neutral200":"#f6f6f6","neutral300":"#e6e6e6","neutral400":"#ddd","neutral600":"#ccc","neutral700":"#b3b3b3","neutral800":"#9b9b9b","neutral900":"#838383","neutral1000":"#6b6b6b","dark":"#000","dark100":"#222","light":"#fff","danger":"#ff0000","danger100":"#CB5A5E","danger200":"#b53438","Success":"#3c763d","Success100":"#2bb673","Success200":"#155724","Warning":"#dab137","Warning100":"#ff713e","Warning200":"#f20000","Info":"#31708F","Info100":"#EEF7FB","Info200":"#90dbee","Info300":"#A6E1EC","Info400":"#22839d","Info600":"#4C8AF6","Info700":"#4051B5","TypoSemiBold":"\"OpenSans-Semibold\", sans-serif","TypoBold":"\"OpenSans-Bold\", sans-serif","TypoRegular":"\"Open Sans\", sans-serif","TypoExtraBold":"\"OpenSans-Extrabold\", sans-serif","rts1":"0.75rem","rts2":"0.8125rem","rts3":"0.875rem","rts4":"0.9375rem","rts5":"1rem","heading1":"1.25rem","heading2":"1.5rem","heading3":"1.625rem","heading4":"1.75rem","heading5":"1.875rem"};
styleInject(css_248z$4);

var css_248z$3 = "";
var styles = {"primary":"#5cb960","primary100":"#4ccb87","primary200":"#3c763d","primary300":"#155724","secondary":"#c0a456","secondary100":"#FCD67F","neutral":"#aaa","neutral100":"#FCFCFC","neutral200":"#f6f6f6","neutral300":"#e6e6e6","neutral400":"#ddd","neutral600":"#ccc","neutral700":"#b3b3b3","neutral800":"#9b9b9b","neutral900":"#838383","neutral1000":"#6b6b6b","dark":"#000","dark100":"#222","light":"#fff","danger":"#ff0000","danger100":"#CB5A5E","danger200":"#b53438","Success":"#3c763d","Success100":"#2bb673","Success200":"#155724","Warning":"#dab137","Warning100":"#ff713e","Warning200":"#f20000","Info":"#31708F","Info100":"#EEF7FB","Info200":"#90dbee","Info300":"#A6E1EC","Info400":"#22839d","Info600":"#4C8AF6","Info700":"#4051B5","TypoSemiBold":"\"OpenSans-Semibold\", sans-serif","TypoBold":"\"OpenSans-Bold\", sans-serif","TypoRegular":"\"Open Sans\", sans-serif","TypoExtraBold":"\"OpenSans-Extrabold\", sans-serif","rts1":"0.75rem","rts2":"0.8125rem","rts3":"0.875rem","rts4":"0.9375rem","rts5":"1rem","heading1":"1.25rem","heading2":"1.5rem","heading3":"1.625rem","heading4":"1.75rem","heading5":"1.875rem"};
styleInject(css_248z$3);

var css_248z$2 = "";
var defaults = {"primary":"#1a1a71","primary100":"#2e4295","primary200":"#253fc8","primary300":"#2219a3","primary400":"#110887","primary600":"#0b065c","primary700":"#06032e","primary800":"#030118","primary900":"#010006","secondary":"#ededed","secondary100":"#ddd","neutral":"#aaa","neutral100":"#FCFCFC","neutral200":"#f6f6f6","neutral300":"#e6e6e6","neutral400":"#ddd","neutral600":"#ccc","neutral700":"#b3b3b3","neutral800":"#9b9b9b","neutral900":"#838383","neutral1000":"#6b6b6b","dark":"#000","dark100":"#222","light":"#fff","danger":"#ff0000","danger100":"#CB5A5E","danger200":"#b53438","Success":"#3c763d","Success100":"#2bb673","Success200":"#155724","Warning":"#dab137","Warning100":"#ff713e","Warning200":"#f20000","Info":"#31708F","Info100":"#EEF7FB","Info200":"#90dbee","Info300":"#A6E1EC","Info400":"#22839d","Info600":"#4C8AF6","Info700":"#4051B5","TypoSemiBold":"\"OpenSans-Semibold\", sans-serif","TypoBold":"\"OpenSans-Bold\", sans-serif","TypoRegular":"\"Open Sans\", sans-serif","TypoExtraBold":"\"OpenSans-Extrabold\", sans-serif","rts1":"0.75rem","rts2":"0.8125rem","rts3":"0.875rem","rts4":"0.9375rem","rts5":"1rem","heading1":"1.25rem","heading2":"1.5rem","heading3":"1.625rem","heading4":"1.75rem","heading5":"1.875rem"};
styleInject(css_248z$2);

var css_248z$1 = "";
var brightview = {"primary":"#0071cd","primary100":"#0072ce","primary200":"#4c8af6","primary300":"#0071ce","primary400":"#015eaa","primary600":"#0073cd","primary700":"#f2f6f7","primary800":"#f4f8fc","primary900":"#f1f6f7","secondary":"#8bc400","secondary100":"#78c624","secondary200":"rgba(139, 196, 0, 0.168627451)","neutral":"#b3b3b3","neutral100":"#f2f2f2","neutral200":"#e4e4e4","neutral300":"rgba(0, 0, 0, 0.0431372549)","neutral400":"#f9f9f9","neutral600":"#e8e8e8","neutral700":"#5a5a5a","neutral800":"#f6f6f6","neutral900":"#ddd","neutral1000":"#57585a","neutral1001":"#57585a","neutral1002":"#57585a","neutral1003":"#57585a","neutral1004":"#57585a","neutral1005":"#57585a","neutral1006":"#57585a","neutral1007":"#57585a","neutral1008":"#57585a","neutral1009":"#ccc","neutral1100":"#e9ecef","neutral1101":"#262626","neutral1102":"#f7f7f7","neutral1103":"#57585a","neutral1104":"rgba(0, 0, 0, 0.1490196078)","neutral1105":"#323130","yellow":"#ffc107","danger":"#f00","danger100":"rgba(255, 0, 0, 0.0901960784)","warning":"#fc9404","warning100":"rgba(252, 148, 4, 0.1098039216)","black":"#000","dark":"#222","dark100":"#333","dark200":"#555","dark300":"#212529","light":"#fff","Info":"#31708f","Info100":"#eef7fb","Info200":"#90dbee","Info300":"#a6e1ec","Info400":"#22839d","Info600":"#4c8af6","Info700":"#4051b5","TypoSemiBold":"HelveticaNeueMedium, sans-serif","TypoBold":"HelveticaNeueBold, sans-serif","TypoRegular":"HelveticaNeue, sans-serif","TypoThin":"HelveticaNeueThin, sans-serif","TypoLight":"HelveticaNeueLight, sans-serif","rts1":"0.8571rem","rts2":"0.9285rem","rts3":"1rem","rts4":"1.0714rem","rts5":"1.1428rem","rts6":"1.2142rem","rts7":"1.2857rem","rts8":"1.3571rem","heading1":"1.4285rem","heading2":"1.5714rem","heading3":"1.7142rem","heading4":"1.8571rem","heading5":"2rem","heading6":"2.1428rem"};
styleInject(css_248z$1);

var css_248z = "";
var usssa = {};
styleInject(css_248z);

const customThemes = (theme) => {
    switch (theme) {
        case 'MyKomatsu':
            let KomatsuThemeColor = {
                ...MyKomatsu
            };
            return loadTheme({
                palette: KomatsuThemeColor
            });
        case 'custom':
            let customThemeColor = {
                ...styles
            };
            return loadTheme({
                palette: customThemeColor
            });
        case 'brightview':
            let brightviewThemeColor = {
                ...brightview
            };
            return loadTheme({
                palette: brightviewThemeColor
            });
        case 'usssa':
            let usssaThemeColor = {
                ...usssa
            };
            return loadTheme({
                palette: usssaThemeColor
            });
        default:
            let defaultThemeColor = {
                ...defaults
            };
            return loadTheme({
                palette: defaultThemeColor
            });
    }
};

const CustomChartThemes = () => {
    const customChartTheme = ['#ff564a', '#ffd044', '#4dd447', '#00b7ca', '#0075f4', '#b93fbb', '#ff837b', '#ffdc73', '#82df70', '#ffb9ea', '#00e4fa', '#b5dbff', '#ebef62', '#a1ddde', '#00e172', '#fcc152', '#ff936b', '#4d67dc', '#fe00e3'];
    return (customChartTheme);
};

const DefaultChartThemes = () => {
    const defaultChartTheme = ['#1A374D', '#406882', '#6998AB', '#B1D0E0', '#D3DEDC', '#92A9BD', '#7C99AC', '#FFEFEF', '#fffEFE', '#ffb9ea', '#00e4fa', '#b5dbff', '#ebef62', '#a1ddde', '#00e172', '#fcc152', '#ff936b', '#4d67dc', '#fe00e3'];
    return (defaultChartTheme);
};

const SofturaChartThemes = () => {
    const softuraChartTheme = ['#1a1a71', '#01ad51', '#fbaf2c', '#6C3A93', '#c21e5f', '#d82b36', '#5d99d2', '#00b9d8', '#2f4ca0', '#ffb9ea', '#00e4fa', '#b5dbff', '#ebef62', '#a1ddde', '#00e172', '#fcc152', '#ff936b', '#4d67dc', '#fe00e3'];
    return (softuraChartTheme);
};

const KACChartThemes = () => {
    const KACChartTheme = ['#f22', '#ffd46e', '#00bbd7', '#71baff', '#d0d458', '#00c9cd', '#00b64d', '#d59d2b', '#ff6522', '#2940a9', '#bb00a6', '#ffb9ea', '#00e4fa', '#b5dbff', '#ebef62', '#a1ddde', '#00e172', '#fcc152', '#ff936b', '#4d67dc', '#fe00e3'];
    return (KACChartTheme);
};

export { CustomChartThemes, DefaultChartThemes, KACChartThemes, SofturaChartThemes, customThemes };
